import { useSuspenseQuery } from '@tanstack/react-query';
import { mantangApi as api } from '@/shared/api';
import { carKeys } from '../api/car.keys';

const useUserCarInfo = () => {
	const { data: carInfo } = useSuspenseQuery({
		queryFn: async () => {
			const result = await api.getUserCarInfo();
			return result.data;
		},
		queryKey: carKeys.userCarInfo(),
	});

	return {
		carInfo,
	};
};

export default useUserCarInfo;
